<template>
<v-dialog width="1000" v-model="show">
  <slot slot="activator" name="activator">
    <v-btn block color="primary">
      {{ $t('related.new_related_data') }}
    </v-btn>
  </slot>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('related.new_related_data') }} - {{schema.name}}
    </v-card-title>
    <v-container>
      <v-form ref="form" v-model="valid" v-on:submit="save">
        <v-flex xs8>
          <v-text-field v-model="name" :rules="nameRules" :label="`${$t('related.name')}`" required></v-text-field>
        </v-flex>
        <v-flex xs8>
          <v-text-field v-model="code" :label="`${$t('related.code')}`" required></v-text-field>
        </v-flex>
        <div>
          <h3> {{ $t('related.schema_keys') }} : </h3>
          <div :key="index" v-for="(keyName, index) in schema.keys">
            <v-layout>
              <v-flex xs5 sm3>
                <v-text-field style="margin-left:2rem;" v-model="values[index]" :label="schema.keys[index].name" required></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>

        <v-btn type="submit">
          {{ $t('archive.filter.save') }}
        </v-btn>
      </v-form>
    </v-container>
  </v-card>
</v-dialog>
</template>
<script>
import http from '@/plugins/http'

export default {
  components: {},
  props: ["schema"],
  data() {
    return {
      name: "",
      code: "",
      valid: false,
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => (!!v && (v.length <= 100 && v.length > 1)) || this.$t('validator.wrong_length')
      ],
      values: [],
      keysSchemaName: [""],
      show: false
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  methods: {
    save(e) {
      e.preventDefault();
      if (this.valid) {
        http.post('related/schema/' + this.schema.id + '/values', this.getPayload())
          .then((data) => {
            this.$emit("created", data.data)
            this.$refs.form.reset()
            this.show = false;
            this.showMessage(this.$t('related.value_created'), "success")
          }).catch(() => {
            this.showMessage(this.$t('related.value_create_error'), "danger")
          })
      }
    },
    getPayload() {
      let payload = {}
      payload.name = this.name
      payload.code = this.code
      payload.values = this.values
        .map((value, index) => ({
          "order": this.schema.keys[index].order,
          "value": value
        }))

      return payload;
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}
</style>
